import { useCallback, useState } from 'react';
import { correctServiceLogValue } from '../../api/serviceLogsApi';
import { ServiceLogRef } from '../../types/serviceLogs';

/** Saving state for one value correction; `save` resolves true on success. */
export const useServiceLogCorrection = () => {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const save = useCallback(async (logRef: ServiceLogRef, value: number, reason?: string): Promise<boolean> => {
        setSaving(true);
        setError(null);
        try {
            await correctServiceLogValue(logRef, value, reason);
            return true;
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Kunde inte spara korrigeringen');
            return false;
        } finally {
            setSaving(false);
        }
    }, []);

    const clearError = useCallback(() => setError(null), []);

    return { save, saving, error, clearError };
};
